import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/index.jsx';
import { pickLang } from '../content.jsx';
import { fetchPosts } from '../news.js';
import { PostCard } from '../pages/site/News.jsx';

// Home page: the 3 latest published posts (hidden when there are none).
export default function LatestNews() {
  const { t } = useI18n();
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    let alive = true;
    fetchPosts(3).then((d) => alive && setPosts(d.items)).catch(() => {});
    return () => { alive = false; };
  }, []);
  if (!posts.length) return null;
  return (
    <section className="section news-latest">
      <div className="container">
        <header className="section-head section-head-row">
          <div>
            <h2>{t('news.latestTitle')}</h2>
            <p className="muted">{t('news.latestLead')}</p>
          </div>
          <Link to="/news" className="btn btn-ghost">{t('news.allNews')} →</Link>
        </header>
        <div className="news-grid">{posts.map((p) => <PostCard key={p.id} post={p} />)}</div>
      </div>
    </section>
  );
}
export { pickLang };
